import axios from "axios";
import { Url, getUser, setUser } from "../../Constants/globals";
import RefreshToken from "../RefreshToken/RefreshToken";

async function me() {
  try {
    const response = await axios.get(Url + "/users/me/", {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    const userInfo = {
      id: response.data.id,
      full_name: response.data.full_name,
      email: response.data.email,
      theme: response.data.theme,
    };
    localStorage.setItem("user", JSON.stringify({ ...getUser(), info: userInfo }));
    setUser({ ...getUser(), info: userInfo });
    return response.data.permissions;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await me();
      } else {
        window.location.reload();
      }
    }
    else {
      await localStorage.removeItem("user");
      window.location = "/";
      return err;
    }
  };
}

export default me;